import "@/styles/figma-tokens.css";
import "@/styles/globals.css";

import { appRootElement } from "app-root-element";
import { createRoot } from "react-dom/client";

import { App } from "@/app/app";

createRoot(appRootElement!).render(<App />);
